<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <!-- Tabs -->
  <ul class="nav nav-tabs d-flex" role="tablist">
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" [class.active]="activeTab==='employerCredits'"
        (click)="setActiveTab('employerCredits')" type="button">
        Employer Credits
      </button>
    </li>
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" [class.active]="activeTab==='creditRiskRequests'"
        (click)="setActiveTab('creditRiskRequests')" type="button">
        Credit Line Requests
      </button>
    </li>
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" [class.active]="activeTab==='pendingApprovals'"
        (click)="setActiveTab('pendingApprovals')" type="button">
        Pending Approvals
        <span class="badge bg-danger ms-1">{{this.pendingApprovals.length}}</span>
      </button>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content mt-3">
    <!-- Employer Credits -->
    <div class="tab-pane fade" [class.show]="activeTab==='employerCredits'"
      [class.active]="activeTab==='employerCredits'">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
            <div class="d-flex align-items-center gap-2 flex-nowrap">

              <!-- Search input -->
              <div class="position-relative flex-grow-1 min-width-0">
                <input id="searchUser" type="text" class="form-control credit-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="searchText" (input)="performSearch()" />

                <span class="search-icon" (click)="performSearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>

              <!-- Advanced Filter -->
              <div class="flex-shrink-0 advanced-filter-wrapper">
                <app-filter-panel #filterPanel title="Advanced Filter" [fields]="filterFields"
                  (filterApplied)="onEcFilter($event)" (filterCleared)="onEcClear()">
                </app-filter-panel>
              </div>

            </div>
          </div>

          <div *ngIf="ecIsLoading" class="text-muted">Loading employer credits...</div>
          <!-- <div *ngIf="!ecIsLoading && ecError" class="text-danger">{{ ecError }}</div> -->
          <!-- Empty State -->
          <div *ngIf="(filteredEmployerCredits.length === 0 || ecError) && !ecIsLoading" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Employer Credits Found.</p>
          </div>

          <div *ngIf="filteredEmployerCredits.length > 0 && !ecError" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">Company Name</th>
                  <th class="table-title text-start">Company ID</th>
                  <th class="table-title text-start">Registered No.</th>
                  <th class="table-title text-start">Credit Limit</th>
                  <th class="table-title text-start">Available Credit Limit</th>
                  <th class="table-title text-start">Status</th>
                  <th class="table-title text-end" style="width: 56px;">
                    <i class="bi bi-pencil-square"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of filteredEmployerCredits">
                  <td class="table-data-text text-start">{{ c.companyName }}</td>
                  <td class="table-data-text text-start">{{ c.companyId || '-' }}</td>
                  <td class="table-data-text text-start">{{ c.companyRegNo || '-' }}</td>
                  <td class="table-data-text text-start">{{ c.creditLimit | number:'1.2-2' }}</td>
                  <td class="table-data-text text-start">{{ c.availableCreditLimit | number:'1.2-2' }}</td>
                  <td class="table-data-text text-start">
                    <span class="badge" [class.bg-success]="(c.status || 'Approved')==='Approved'">{{ c.status ||
                      'Approved' }}</span>
                  </td>
                  <td class="table-data-text text-end">
                    <button class="btn p-0" style="background: none; border: none;" (click)="openCreditLineRequest(c)">
                      <i class="bi bi-pencil-square" style="color: var(--primary-color);"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <app-paginator [serverSide]="true" [totalItems]="ecTotal" [pageSize]="ecPageSize"
              [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onEmployerCreditPageChange($event)">
            </app-paginator>
          </div>
        </div>
      </div>
    </div>

    <!-- Credit Line Requests -->
    <div class="tab-pane fade" [class.show]="activeTab==='creditRiskRequests'"
      [class.active]="activeTab==='creditRiskRequests'">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
            <div class="d-flex align-items-center gap-2">

              <!-- Search input -->
              <div class="position-relative flex-grow-1">
                <input id="searchUser" type="text" class="form-control credit-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="clrSearchText" (input)="performClrSearch()" />

                <span class="search-icon" (click)="performClrSearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>

              <!-- Advanced Filter -->
              <div class="flex-shrink-0 advanced-filter-wrapper">
                <app-filter-panel #filterPanel title="Advanced Filter" [fields]="filterFields"
                  (filterApplied)="onClrFilter($event)" (filterCleared)="onClrClear()">
                </app-filter-panel>
              </div>

            </div>
          </div>

          <div *ngIf="clrIsLoading" class="text-muted">Loading requests...</div>
          <!-- <div *ngIf="!clrIsLoading && clrError" class="text-danger">{{ clrError }}</div> -->
          <!-- Empty State -->
          <div *ngIf="(filteredCreditLineRequests.length === 0 || clrError) && !clrIsLoading" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Credit Line Requests Found.</p>
          </div>

          <div *ngIf="filteredCreditLineRequests.length > 0 && !clrError" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">Company Name</th>
                  <th class="table-title text-start">Company ID</th>
                  <th class="table-title text-start">Registered No.</th>
                  <th class="table-title text-end">
                    <i class="bi bi-eye"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of filteredCreditLineRequests">
                  <td class="table-data-text text-start">{{ r.companyName }}</td>
                  <td class="table-data-text text-start">{{ r.companyId || '-' }}</td>
                  <td class="table-data-text text-start">{{ r.companyRegNo }}</td>
                  <td class="table-data-text text-end">
                    <button class="btn p-0" style="background: none; border: none;"
                      (click)="openCreditLineRequest(r)"><i class="bi bi-arrow-right"
                        style="color: var(--primary-color);"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>

            <app-paginator [serverSide]="true" [totalItems]="clrTotal" [pageSize]="clrPageSize"
              [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onCreditLineRequestsPageChange($event)">
            </app-paginator>
          </div>
        </div>
      </div>
    </div>

    <!-- Pending Approvals (placeholder) -->
    <div class="tab-pane fade" [class.show]="activeTab==='pendingApprovals'"
      [class.active]="activeTab==='pendingApprovals'">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
            <div class="d-flex align-items-center gap-2">

              <!-- Search input -->
              <div class="position-relative flex-grow-1">
                <input id="searchUser" type="text" class="form-control credit-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="pendingSearchText" (input)="performPendingSearch()" />

                <span class="search-icon" (click)="performPendingSearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>

              <!-- Advanced Filter -->
              <div class="flex-shrink-0 advanced-filter-wrapper">
                <app-filter-panel #filterPanel title="Advanced Filter" [fields]="filterFields"
                  (filterApplied)="onPaFilter($event)" (filterCleared)="onPaClear()">
                </app-filter-panel>
              </div>

            </div>
          </div>

          <div *ngIf="paIsLoading" class="text-muted">Loading approvals...</div>
          <!-- <div *ngIf="!paIsLoading && paError" class="text-danger">{{ paError }}</div> -->
          <!-- Empty State -->
          <div *ngIf="(filteredPendingApprovals.length === 0 || paError) && !paIsLoading" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Pending Approvals Found.</p>
          </div>

          <div *ngIf="filteredPendingApprovals.length > 0 && !paError" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">Company Name</th>
                  <th class="table-title text-start">Company ID</th>
                  <th class="table-title text-start">Registered No.</th>
                  <th class="table-title text-end">
                    <i class="bi bi-eye"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of filteredPendingApprovals">
                  <td class="table-data-text text-start">{{ p.companyName }}</td>
                  <td class="table-data-text text-start">{{ p.companyId || '-' }}</td>
                  <td class="table-data-text text-start">{{ p.companyRegNo }}</td>
                  <td class="table-data-text text-end">
                    <button class="btn p-0" style="background: none; border: none;" (click)="openPendingApproval(p)"><i
                        class="bi bi-arrow-right" style="color: var(--primary-color);"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>

            <app-paginator [serverSide]="true" [totalItems]="paTotal" [pageSize]="paPageSize"
              [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onPendingApprovalsPageChange($event)">
            </app-paginator>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</div>

<!-- Credit Line Request Offcanvas -->
<div #creditLineRequestOffcanvas class="offcanvas offcanvas-end w-50" tabindex="-1" id="creditLineRequestOffcanvas"
  aria-labelledby="creditLineRequestOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="creditLineRequestOffcanvasLabel">{{ selectedCompany?.companyName }}</h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="closeOffcanvas()"></button>
  </div>
  <div class="offcanvas-body">
    <form *ngIf="offcanvasContext==='request'; else pendingSummary" [formGroup]="creditLineForm">
      <!-- Inputs with Add buttons -->
      <div class="container-fluid">

        <!-- Credit Limit -->
        <div class="row mb-3">
          <label class="col-12 col-md-4 col-lg-3 col-form-label">
            Credit Limit
          </label>

          <div class="col-12 col-md-8 col-lg-6">
            <app-formatted-number-input
              formControlName="creditLimit"
              placeholder="Enter credit limit"
              inputClass="form-control"
              [min]="0" [max]="999999999999.99"
              [decimalPlaces]="2"
              [isInvalid]="creditLineForm.get('creditLimit')?.invalid && creditLineForm.get('creditLimit')?.touched" />

            <div class="text-danger small mt-1"
              *ngIf="creditLineForm.get('creditLimit')?.invalid && creditLineForm.get('creditLimit')?.touched">
              <span *ngIf="creditLineForm.get('creditLimit')?.errors?.['required']">Credit Limit is required</span>
              <span *ngIf="creditLineForm.get('creditLimit')?.errors?.['min']">Credit Limit must be >= 0</span>
            </div>
          </div>
        </div>

        <!-- Wage Withdrawal % -->
        <div class="row mb-3">
          <label class="col-12 col-md-4 col-lg-3 col-form-label">
            Wage Withdrawal %
          </label>

          <div class="col-12 col-md-8 col-lg-6">
            <div class="input-group">
              <input type="number" class="form-control" placeholder="Enter wage withdrawal %" formControlName="wageWithdrawalPercentage" min="0" max="100"
                step="0.01" style="padding-left: 1.55rem;" (input)="onWageWithdrawalInput($event)"
                [class.is-invalid]="creditLineForm.get('wageWithdrawalPercentage')?.invalid && creditLineForm.get('wageWithdrawalPercentage')?.touched" />
              <span class="input-group-text">%</span>
            </div>

            <div class="text-danger small mt-1"
              *ngIf="creditLineForm.get('wageWithdrawalPercentage')?.invalid && creditLineForm.get('wageWithdrawalPercentage')?.touched">
              <span *ngIf="creditLineForm.get('wageWithdrawalPercentage')?.errors?.['required']">Wage Withdrawal % is
                required</span>
              <span *ngIf="creditLineForm.get('wageWithdrawalPercentage')?.errors?.['min']">Must be >= 0</span>
              <span *ngIf="creditLineForm.get('wageWithdrawalPercentage')?.errors?.['max']">Cannot exceed 100</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Rollovers -->
      <div class="container-fluid">
        <div class="card border-0 shadow-sm  info-card-glow">
          <div class="card-body p-4">
            <!-- Header -->
            <div class="mb-4">
              <h5 class="card-title mb-1">Rollovers Configuration</h5>
              <p class="text-muted small mb-0">Select rollover percentages and days for credit line management</p>
            </div>

            <!-- Percentages Section -->
            <div class="mb-4">
              <div class="d-flex align-items-center mb-3">
                <div class="bg-primary bg-opacity-10 rounded-circle p-2 me-3"
                  style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                  <i class="bi bi-percent text-primary"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-semibold">Percentages</h6>
                  <small class="">Choose applicable rollover percentages</small>
                </div>
              </div>

              <div class="d-flex flex-wrap gap-3 ms-5 ps-3">
                <div *ngFor="let option of rollOverPercentages" class="percentage-option position-relative"
                  [class.selected]="isPercentageChecked(option.rollOverPercentageId)">
                  <input type="checkbox" class="form-check-input position-absolute top-0 end-0 m-2 checkbox-small"
                    [id]="'percentage-' + option.rollOverPercentageId"
                    [checked]="isPercentageChecked(option.rollOverPercentageId)"
                    (change)="onPercentageChange(option, $event)" style="cursor: pointer; z-index: 2;" />
                  <label [for]="'percentage-' + option.rollOverPercentageId"
                    class="d-flex flex-column align-items-center justify-content-center text-center w-100 h-100"
                    style="cursor: pointer;">
                    <div class="percentage-value">{{ option.rollOverPercentage }}%</div>
                  </label>
                </div>
              </div>
            </div>

            <!-- Divider -->
            <hr class="my-4">

            <!-- Days Section -->
            <div class="mb-4">
              <div class="d-flex align-items-center mb-3">
                <div class="bg-success bg-opacity-10 rounded-circle p-2 me-3"
                  style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                  <i class="bi bi-calendar-check text-success"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-semibold">Days</h6>
                  <small class="">Select rollover duration in days</small>
                </div>
              </div>

              <div class="d-flex flex-wrap gap-3 ms-5 ps-3">
                <div *ngFor="let option of rollOverDays" class="day-option position-relative"
                  [class.selected]="isDayChecked(option.rollOverDayId)">
                  <input type="checkbox" class="form-check-input position-absolute top-0 end-0 m-2 checkbox-small"
                    [id]="'day-' + option.rollOverDayId" [checked]="isDayChecked(option.rollOverDayId)"
                    (change)="onDayChange(option, $event)" style="cursor: pointer; z-index: 2;" />
                  <label [for]="'day-' + option.rollOverDayId"
                    class="d-flex flex-column align-items-center justify-content-center text-center w-100 h-100"
                    style="cursor: pointer;">
                    <div class="day-value">{{ option.rollOverDay }}</div>
                    <small class="day-label">days</small>
                  </label>
                </div>
              </div>
            </div>

            <!-- Action Button -->
            <div class="d-flex justify-content-end mt-4 pt-3 border-top">
              <button type="button" class="btn btn-success px-4 py-2 d-flex align-items-center gap-2"
                *ngIf="authService.canAdd('creditRisk.manageCredit')" (click)="sendForApproval()"
                [disabled]="creditLineForm.invalid">
                <i class="bi bi-send-check" style="color: white !important;"></i>
                Send for Approval
              </button>
            </div>
          </div>
        </div>
      </div>

    </form>

    <ng-template #pendingSummary>

      <!-- Status Banner -->
      <div class="pending-status-banner mb-4">
        <div class="d-flex align-items-center gap-2">
          <div class="pending-pulse-dot"></div>
          <span class="pending-status-text">Awaiting Review</span>
        </div>
        <span class="pending-status-reg" *ngIf="selectedPending?.companyRegNo">
          Reg No: {{ selectedPending?.companyRegNo }}
        </span>
      </div>

      <!-- Metrics inside a theme card -->
      <div class="card info-card-glow mb-4">
        <div class="card-body p-4">
          <div class="row g-4">

            <!-- Credit Limit -->
            <div class="col-6">
              <div class="approval-metric-item">
                <div class="approval-metric-icon-wrap">
                  <i class="bi bi-bank"></i>
                </div>
                <div>
                  <div class="approval-metric-label">Credit Limit</div>
                  <div class="approval-metric-value">{{ selectedPending?.creditLimit | number:'1.2-2' }}</div>
                </div>
              </div>
            </div>

            <!-- Wage Withdrawal -->
            <div class="col-6">
              <div class="approval-metric-item">
                <div class="approval-metric-icon-wrap">
                  <i class="bi bi-wallet2"></i>
                </div>
                <div>
                  <div class="approval-metric-label">Wage Withdrawal</div>
                  <div class="approval-metric-value">{{ selectedPending?.wageWithdrawalPercentage }}<span class="approval-metric-unit">%</span></div>
                </div>
              </div>
            </div>

            <!-- Rollover Percentage -->
            <div class="col-6">
              <div class="approval-metric-item">
                <div class="approval-metric-icon-wrap">
                  <i class="bi bi-percent"></i>
                </div>
                <div>
                  <div class="approval-metric-label">Rollover Percentage</div>
                  <div class="approval-metric-value">{{ selectedPending?.rollOverPercentage }}<span class="approval-metric-unit">%</span></div>
                </div>
              </div>
            </div>

            <!-- Rollover Days -->
            <div class="col-6">
              <div class="approval-metric-item">
                <div class="approval-metric-icon-wrap">
                  <i class="bi bi-calendar-check"></i>
                </div>
                <div>
                  <div class="approval-metric-label">Rollover Days</div>
                  <div class="approval-metric-value">{{ selectedPending?.rollOverDay }}<span class="approval-metric-unit">days</span></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Approval Actions -->
      <div *ngIf="authService.canReview('creditRisk.manageCredit')" class="approval-actions-bar">
        <button type="button" class="btn approval-btn-reject" (click)="rejectPending()">
          <i class="bi bi-x-circle"></i>
          Reject
        </button>
        <button type="button" class="btn approval-btn-approve" (click)="approvePending()">
          <i class="bi bi-check-circle"></i>
          Approve
        </button>
      </div>

    </ng-template>
  </div>
</div>